"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadCrumb = void 0;
const deep_equal_1 = __importDefault(require("deep-equal"));
/**
 * a generic representation of a breadcrumb
 * @see {@link https://developer.mozilla.org/en-US/docs/Glossary/Breadcrumb | Breadcrumb}
 */
class BreadCrumb {
    /**
     * Construct a new BreadCrumb
     *
     * @param display the display text for a breadcrumb
     * @param url the url to which the breadcrumb navigates
     */
    constructor(display, url) {
        this.display = display;
        this.url = url;
        Object.freeze(this); // enforce js immmutability in addition to ts
    }
    /**
     * Returns true if two breadcrumbs are deeply equal
     *
     * @param other the other breadcrumb
     * @returns true if two breadcrumbs are deeply equal
     */
    equals(other) {
        return (0, deep_equal_1.default)(this, other);
    }
}
exports.BreadCrumb = BreadCrumb;
//# sourceMappingURL=BreadCrumb.js.map